// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoContentBlock_wrapper___Yn10"};